/** Renders Ad from our DFP Ad Slot provider, based on props passed in
 *  Inspired by : https://github.com/oahehc/dfp-examples/tree/master/react-dfp/src
 *
 *  Example AdSlot Sizes                (width, height)
 *      cds_horizontal_box              (720, 300)
 *      cds_horizontal_box_mobile       (300, 250)
 *      house                           (375, 90)
 *      cds_leaderboard                 (728, 90)
 *      cds_leaderboard_mobile          (320, 50)
 *      cds_vertical_box                (300, 600)
 */

import React from "react";
import { DFPSlotsProvider, AdSlot } from "react-dfp";

const DFPAdSlot = ({ width, height, path, slotId = "adSlot-0" }) => {
  return (
    <DFPSlotsProvider dfpNetworkId="59699124">
      <div>
        <AdSlot
          sizes={[[width, height]]}
          adUnit={path}
          slotId={slotId} // ✅ This is what creates the correct DOM ID
        />
      </div>
    </DFPSlotsProvider>
  );
};

export default DFPAdSlot;
